import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { I18nService } from '../../shared/services/i18n.service';

/**
 * Language Guard - sets language BEFORE route activation
 * This ensures:
 * - Language is set before components are created
 * - API interceptors use correct language headers
 * - Translations are loaded before ngOnInit runs
 */
export const langGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const i18nService = inject(I18nService);
  const lang = route.paramMap.get('lang');
  if (lang && i18nService.isValidLangCode(lang) && i18nService.getCurrentLang() !== lang) {
    await i18nService.setLanguage(lang);
  }

  return true;
};

